export const alentours = [
      {
            id: 1,
            titre: "LA HAYE DE ROUTOT",
            img: "/pictures/Alentours/la_haye_de_routot.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/9mfEfYJF5F8Dpqtt8",
      },

      {
            id: 2,
            titre: "LE MOULIN DE HAUVILLE",
            img: "/pictures/Alentours/moulin_de_hauville.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/zrvyXonkxsQJhWVHA",
      },

      {
            id: 3,
            titre: "LES BACS DE SEINE",
            img: "/pictures/Alentours/bac_de_seine.png",
            site: "https://www.normandie-tourisme.fr/bacs-sur-la-seine/",
            maps: "",
      },

      {
            id: 4,
            titre: "L'ABBAYE DE JUMIÈGES",
            img: "/pictures/Alentours/abbaye_de_jumieges.webp",
            site: "",
            maps: "https://maps.app.goo.gl/bmxmhuwMcHVxk5E99",
      },

      {
            id: 5,
            titre: "LA FORÊT DE BROTONNE",
            img: "/pictures/Alentours/foret_brotonne.jpg",
            site: "",
            maps: "https://goo.gl/maps/bPTJ2CYrK9FRZ8CX6",
      },

      {
            id: 6,
            titre: "LES BORDS DE SEINE, LA FOULERIE",
            img: "/pictures/Alentours/bords_de_seine.jpg",
            site: "",
            maps: "https://goo.gl/maps/gHgHsTRiLatmuR5t9",
      },

      {
            id: 7,
            titre: "LA MAISON DU LIN EN NORMANDIE",
            img: "/pictures/Alentours/la_maison_du_lin.JPG",
            site: "https://www.terresvivantes-normandie.fr/maison-du-lin/",
            maps: "https://goo.gl/maps/K1TMPJN5AberMWeXA",
      },

      {
            id: 8,
            titre: "LA FERME LULU MARKET",
            img: "/pictures/Alentours/lulu_market_2.jpg",
            site: "https://earl-la-chapelle-brestot.jimdofree.com/",
            maps: "https://goo.gl/maps/xQnou5uTPp8uvqo87",
      },

      {
            id: 9,
            titre: "PONT-AUDEMER",
            img: "/pictures/Alentours/pont_audemar2.png",
            site: "https://www.tourisme-pontaudemer-rislenormande.com/",
            maps: "https://maps.app.goo.gl/JrP2JWuUW3PBGfEc7",
      },

      {
            id: 10,
            titre: "LE MANOIR DE VILLERS",
            img: "/pictures/Alentours/manoir_de_villers_1.jpg",
            site: "https://www.manoirdevillers.fr/",
            maps: "https://maps.app.goo.gl/gZfogdowr5M2o8Gt9",
      },

      {
            id: 11,
            titre: "LA BASE DE LOISIRS DE JUMIÈGES",
            img: "/pictures/Alentours/base_jumieges.jpg",
            site: "https://www.basedejumieges.fr/",
            maps: "https://maps.app.goo.gl/ujbBoW3WHjiTR6ew8",
      },

      {
            id: 12,
            titre: "LA BASE DE LOISIRS DE BRIONNE",
            img: "/pictures/Alentours/base_de_loisir_brionne.jpg",
            site: "https://www.ville-brionne.fr/",
            maps: "https://goo.gl/maps/HxEaZZq2mL5ngpaE8",
      },

      {
            id: 13,
            titre: "LE CHÂTEAU DU CHAMP DE BATAILLE",
            img: "/pictures/Alentours/champ_de_bataille.jpg",
            site: "https://www.chateauduchampdebataille.com/",
            maps: "https://maps.app.goo.gl/WC8RX7n1Sz7TnBDo8",
      },

      {
            id: 14,
            titre: "L'ABBAYE DU BEC",
            img: "/pictures/Alentours/abbaye_bec.png",
            site: "https://abbayedubec.org/",
            maps: "https://maps.app.goo.gl/x7rKJNgeytNzRxy2A",
      },

      {
            id: 15,
            titre: "LE CHÂTEAU DE MARTAINVILLE",
            img: "/pictures/Alentours/chateau_de_martainville.png",
            site: "", // A REVOIR
            maps: "https://maps.app.goo.gl/nPv2gKruF47XgQeg7",
      },


      {
            id: 34,
            titre: "LE CHÂTEAU DE VASCOEUIL",
            img: "/pictures/Alentours/chateau_vascoeuil.jpg",
            site: "https://www.chateauvascoeuil.com/",
            maps: "https://maps.app.goo.gl/9K3LGHGQ67JEayHs5"
      },

      {
            id: 16,
            titre: "ROUEN",
            img: "/pictures/Alentours/rouen_tourisme.jpg",
            site: "https://www.visiterouen.com/",
            maps: "https://maps.app.goo.gl/PVHxtPcJphTCZ38dA",
      },

      {
            id: 17,
            titre: "L'ABBAYE SAINT-GEORGES",
            img: "/pictures/Alentours/abbaye-saint-georges.jpg",
            site: "http://www.abbaye-saint-georges.com/",
            maps: "https://maps.app.goo.gl/JUcRUumDfqrSTStH9",
      },

      {
            id: 18,
            titre: "LE PARC DU BOCASSE",
            img: "/pictures/Alentours/parc_bocasse_2.png",
            site: "https://www.parcdubocasse.fr/",
            maps: "https://maps.app.goo.gl/oNpZwP2t3fKvZYaaA",
      },

      {
            id: 19,
            titre: "L'ABBAYE DE BONPORT",
            img: "/pictures/Alentours/abbaye_bon_port.png",
            site: "https://www.abbayedebonport.com/",
            maps: "https://maps.app.goo.gl/nkcfAFYEczPru8Cz5",
      },

      {
            id: 20,
            titre: "L'ABBAYE DE SAINT-WANDRILLE",
            img: "/pictures/Alentours/abbaye_saint_wandrille.jpg",
            site: "https://st-wandrille.com/",
            maps: "https://maps.app.goo.gl/4SmoYSUJGdG9wtu38",
      },

      {
            id: 21,
            titre: "LE CHÂTEAU DE MONFORT SUR RISLES",
            img: "/pictures/Alentours/chateau_de_monfort.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/Js5m7xBCedCAkAcz5",
      },

      {
            id: 22,
            titre: "LE PONT DE NORMANDIE",
            img: "/pictures/Alentours/pont_normandie.png",
            site: "http://www.pontsnormandietancarville.fr/",
            maps: "https://maps.app.goo.gl/m4ncBgnQFbfVXtAY8",
      },

      {
            id: 23,
            titre: "LE DOMAINE D'HARCOURT",
            img: "/pictures/Alentours/harcourt_normandie.jpg",
            site: "http://www.harcourt-normandie.fr/",
            maps: "https://goo.gl/maps/WBFXQXRFfXeV5WTMA",
      },

      {
            id: 24,
            titre: "LERY POSES",
            img: "/pictures/Alentours/lery_poses.jfif",
            site: "http://www.lery-poses.fr/",
            maps: "https://maps.app.goo.gl/AQQ2Q9kHCTUrZUTbA",
      },

      {
            id: 25,
            titre: "LES ESCARGOTS DE BROTONNE",
            img: "/pictures/Alentours/escargot_de_brotonne.png",
            site: "https://escargotsdebrotonne.com/",
            maps: "https://maps.app.goo.gl/A1EHM1SBUSKkYsdJ6",
      },

      {
            id: 26,
            titre: "LES ECURIES DU QUESNEY",
            img: "/pictures/Alentours/ecuries_du_quesney.png",
            site: "https://www.lesecuriesduquesney.fr/",
            maps: "https://maps.app.goo.gl/cvmCXBxoiYz1i3BP7",
      },

      {
            id: 27,
            titre: "LE PARC DE CLÈRES",
            img: "/pictures/Alentours/parc_le_clerc.jpeg",
            site: "https://www.instagram.com/parcdecleres/",
            maps: "https://maps.app.goo.gl/iFgySb1X2C81bCar5",
      },

      {
            id: 28,
            titre: "HONFLEUR TERRE D'ESTUAIRE",
            img: "/pictures/Alentours/honfleur.jpg",
            site: "https://www.ot-honfleur.fr/",
            maps: "https://maps.app.goo.gl/gor7k4uPyrQFAxwk7",
      },

      {
            id: 29,
            titre: "LE THÉÂTRE ROMAIN DE LILLEBONNE",
            img: "/pictures/Alentours/theatre_romain_lillebone.webp",
            site: "",
            maps: "https://maps.app.goo.gl/bZuwgsZMaznUhcKp7",
      },

      {
            id: 30,
            titre: "LE CHÂTEAU DE ROBERT LE DIABLE",
            img: "/pictures/Alentours/robert_le_diable.jpg",
            site: "https://www.chateauderobertlediable.fr/",
            maps: "https://goo.gl/maps/tEuYfKJpuhBp36687",
      },

      {
            id: 31,
            titre: "BIOTROPICA",
            img: "/pictures/Alentours/biotropica.jpg",
            site: "https://www.biotropica.fr/",
            maps: "https://goo.gl/maps/6E6qce5GUGXQ8nws5",
      },

      {
            id: 32,
            titre: "LE ZOO DE CERZA",
            img: "/pictures/Alentours/zoo_de_cerza.jpg",
            site: "https://www.cerza.com/",
            maps: "https://goo.gl/maps/8RMKRbqXYexXspj88",
      },

      {
            id: 33,
            titre: "CENTAURE PARIS - NORMANDIE",
            img: "/pictures/Alentours/centaure_normandie_paris.jpg",
            site: "http://paris-normandie.centaure.com/",
            maps: "https://maps.app.goo.gl/LwZpfuCECgXxUu9N6",
      },

      {
            id: 34,
            titre: "LE PHARE DE LA ROQUE, LE MARAIS-VERNIER",
            img: "/pictures/Alentours/phare_de_la_roque.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/k33DL1vsnDPQfcM99",
      },

      {
            id: 35,
            titre: "LE CHÊNE D'ALLOUVILLE",
            img: "/pictures/Alentours/chene_allouville.webp",
            site: "",
            maps: "https://maps.app.goo.gl/QRuaCiwksztnAQLw5",
      },

      {
            id: 36,
            titre: "LA BOUILLE",
            img: "/pictures/Alentours/bouille.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/woCbTdadhHyDETk16",
      },

      {
            id: 37,
            titre: "LE CHÂTEAU GAILLARD",
            img: "/pictures/Alentours/gaillard.jpg",
            site: "",
            maps: "https://maps.app.goo.gl/xcP7mRgMw3bXhyCi6",
      },

      {
            id: 38,
            titre: "LA BASILIQUE DE LISIEUX",
            img: "/pictures/Alentours/lisieux.jpg",
            site: "https://tourisme.lisieux-normandie.fr/",
            maps: "https://maps.app.goo.gl/BPaRmsTQTMRw2wmk7",
      },

];

export const alentoursSiteInformation = [
      {
            id: 1,
            titre: "ROUMOIS SEINE",
            img: "/pictures/Alentours/logo_communaute_roumois_seine.jpg",
            site: "https://www.roumoiseine.fr/",
            maps: "",
      },

      {
            id: 2,
            titre: "PARC NATUREL REGIONAL DES BOUCLES DE LA SEINE NORMANDE",
            img: "/pictures/Alentours/logo_parc_naturel_regional_des_boucles_de_la_seine_normande.jpg",
            site: "https://www.pnr-seine-normande.com/",
            maps: "",
      },

      {
            id: 3,
            titre: "EURÊKA",
            img: "/pictures/Alentours/eureka.jpg",
            site: "https://www.eureka-attractivite.fr/",
            maps: "",
      },

      {
            id: 4,
            titre: "CAUX-SEINE NORMANDIE TOURISME",
            img: "/pictures/Alentours/caux-seine-normandie.jpg",
            site: "https://www.entreseineetmer.fr/",
            maps: "",
      },

      {
            id: 5,
            titre: "SEINE EURE TOURISME",
            img: "/pictures/Alentours/seine_eure_tourisme.jpg",
            site: "https://www.tourisme-seine-eure.com/",
            maps: "",
      },

      {
            id: 6,
            titre: "BIENVENUE À LA FERME",
            img: "/pictures/Alentours/bienvenue_a_la_ferme.jpg",
            site: "https://www.bienvenue-a-la-ferme.com/",
            maps: "",
      },

      {
            id: 7,
            titre: "LA NORMANDIE INFO",
            img: "/pictures/Alentours/logo_normandie_info.jpg",
            site: "https://www.la-normandie.info/",
            maps: "",
      },

      {
            id: 8,
            titre: "GRAINE DE VIKING",
            img: "/pictures/Alentours/logo_graine_vikings.jpg",
            site: "https://openagenda.com/en/grainedeviking",
            maps: "",
      },

      {
            id: 9,
            titre: "EURE MÉDIÉVALE",
            img: "/pictures/Alentours/eure_medievale.png",
            site: "https://euremedievale.fr/",
            class: "black",
            maps: "",
      },

      {
            id: 10,
            titre: "SEINE MARITIME TOURISME",
            img: "/pictures/Alentours/seine_maritime.jpg",
            site: "https://www.seine-maritime-tourisme.com/",
            maps: "",
      },

      {
            id: 11,
            titre: "MUSÉES NORMANDIE",
            img: "/pictures/Alentours/musee_normandie.png",
            site: "https://www.musees-normandie.fr/",
            maps: "",
      },
];
